module.exports = __webpack_public_path__ + "img/payoneer-logo.0870dca1.svg";